/** @jsx jsx */
import { Fragment, h } from 'preact';

// Searchspring
import { getContext } from '@searchspring/snap-toolbox';

// Packages
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';

// Local
import { fetchLocaleField } from '../../Helpers';
import { Prices } from '../../Prices/Prices';

// CSS
import '../../Result/result.css';

export function FixedBundleProductCard({ cardProps: { parentProps, styling, parentSubProps } }) {
	// Destructure relevant data from parent component props
	const { result, className, layout, controller } = parentProps;

	const context = getContext(['region']);
	const core = result?.mappings?.core;
	const hoverImage = result?.attributes?.ss_image_hover;
	const badge = fetchLocaleField(result, 'mfield_cql_badge', 'mfield_french_badge');
	const priceRange = result?.attributes?.ss_price_range ? result?.attributes?.ss_price_range : null;
	const onSale = result?.attributes?.ss_on_sale ? "on--sale" : "not-on--sale";
	const shortDescription = fetchLocaleField(result, 'mfield_cql_short_description');
	const bundleProductTitles = shortDescription?.split(', ');

	// Handle fr product URL
	let productUrl = core.url;
	if (window.Shopify.locale == 'fr') {
		productUrl = `/fr${productUrl}`;
	}

	return (
		<article
			{...styling}
			className={classnames('ss__result', typeof hoverImage != 'undefined' && 'ss__result__hover', `ss__result--${layout}`, className)}
		>
			<a
				href={productUrl} //No variant selection on PLP, so extra logic not needed here.
				onMouseDown={(e) => {
					controller?.track?.product?.click(e, result);
				}}
				className={`ss__result-link ${onSale}`}
				aria-label={core.name}
			>
				<div className="product-card-top-wrapper">
					<div className="ss__result__image-wrapper">
						{badge && <div className="ss__badge ss__result__badge">{badge}</div>}
						<div {...styling} className={classnames('ss__image', 'ss__result__image', 'ss__result__image-fixed-bundle')}>
							<img
								id={`ProductImage-${result.id}`}
								alt={core.name}
								class="product__img product__img--main lazyload"
								data-aspectratio="1.4967637540453074"
								data-sizes="auto"
								data-image
								src={core.imageUrl}
							/>

							{typeof hoverImage != 'undefined' && (
								<img
									id={`ProductImage-${result.id}`}
									alt={core.name}
									class="product__img product__img--hover lazyload"
									data-aspectratio="1.4967637540453074"
									data-sizes="auto"
									data-image
									src={hoverImage}
								/>
							)}
						</div>
					</div>
					<div className="ss__result__details ss__result__details__fixed-bundle">
						<div className="ss__result__details__title ss__result__details__title-fixed-bundle body-medium">{core.name}</div>

						<div class="fixed-bundle-product-titles-wrapper">
							{bundleProductTitles?.map((title) => {
								return <p class="fixed-bundle-product-title">{title}</p>;
							})}
						</div>

						<div className="ss__result__details__top_row body-large">
							<div className="ss__result__details__pricing ss__result__details__pricing-fixed-bundle body-medium">
								{context.region == 'us' && <Prices priceRange={priceRange} core={core} subProps={parentSubProps} />}

								{context.region == 'ca' && <Prices priceRange={priceRange} core={core} subProps={parentSubProps} />}

								{/* Only display UK prices if the market is equal to UK as well. */}
								{context.region == 'uk' && window.Resources.marketHandle == 'uk' && (
									<Prices priceRange={priceRange} core={core} subProps={parentSubProps} />
								)}
							</div>
						</div>
					</div>
				</div>
			</a>
		</article>
	);
}
